<template>
  <div class="agreement-section">
    <div class="agreement-row">
      <div class="checkbox-wrapper" @click="toggleAgreed">
        <span class="checkbox" :class="{ checked: value }">
          <i v-if="value" class="check-icon">✓</i>
        </span>
      </div>
      <div class="agreement-entry">
        <span class="agree-text">我已阅读并同意</span>
        <span
          v-for="(item, i) in agreementItems"
          :key="i"
          class="agree-link"
          @click="openItem(i)"
        >《{{ item.title || '条款' + (i + 1) }}》</span>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round :style="{ maxHeight: '85%' }">
      <div class="popup-header">
        <div class="nav-scroll-container">
          <div class="nav-tabs">
            <span
              v-for="(item, i) in agreementItems"
              :key="i"
              :class="['nav-tab', { active: currentIndex === i }]"
              @click="switchItem(i)"
            >{{ item.title || '条款' + (i + 1) }}</span>
          </div>
        </div>
<!--        <span class="popup-close" @click="show = false">×</span>-->
      </div>
      <div class="popup-body">
        <div class="imgs">
          <img
            v-for="(img, ii) in currentItem.images"
            :key="ii"
            :src="img"
            class="sec-img"
            @click="previewImg(ii)"
          />
        </div>
      </div>
      <div class="popup-footer">
        <button class="agree-btn" @click="handleAgree">我已阅读全部，同意</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import eventBus from '@/utils/eventBus'

export default {
  name: 'AgreementSection',
  props: {
    config: { type: Object, default: () => ({}) },
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      show: false,
      currentIndex: 0
    }
  },
  computed: {
    protocols() {
      return (this.config && this.config.protocols) || []
    },
    agreementItems() {
      const items = []
      this.protocols.forEach(p => {
        if (!p || p.type !== 'file' || !p.content) return
        try {
          const arr = JSON.parse(p.content)
          ;(arr || []).forEach(s => {
            items.push({
              title: s.title || '',
              images: Array.isArray(s.images) ? s.images : (s.images ? String(s.images).split(',') : [])
            })
          })
        } catch (e) {
        }
      })
      return items
    },
    currentItem() {
      return this.agreementItems[this.currentIndex] || { title: '', images: [] }
    }
  },
  watch: {
    agreementItems(arr) {
      if (this.currentIndex >= arr.length) this.currentIndex = 0
    }
  },
  methods: {
    openItem(index) {
      this.currentIndex = index
      this.show = true
    },
    switchItem(index) {
      this.currentIndex = index
    },
    previewImg(imgIndex) {
      ImagePreview({ images: this.currentItem.images, startPosition: imgIndex })
    },
    toggleAgreed() {
      this.$emit('input', !this.value)
    },
    handleAgree() {
      this.show = false
      this.$emit('input', true)
      eventBus.$emit('agreement-agreed')
    }
  }
}
</script>

<style lang="less" scoped>
.agreement-section {
  width: 100%;
  padding: 0 0.3rem;
}

.agreement-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.checkbox-wrapper {
  padding: 0.05rem 0.15rem 0 0;
  cursor: pointer;
  flex-shrink: 0;
}

.checkbox {
  width: 0.32rem;
  height: 0.32rem;
  border: 0.025rem solid #fff;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  cursor: pointer;

  &.checked {
    background: #E7401E;
    border-color: #E7401E;
  }

  .check-icon {
    color: #fff;
    font-size: 0.2rem;
    font-style: normal;
    font-weight: bold;
  }
}

.agreement-entry {
  flex: 1;
  font-size: 0.24rem;
  line-height: 1.6;
  color: #fff;

  .agree-text {
    color: #fff;
  }

  .agree-link {
    color: #fff;
    text-decoration: underline;
    margin: 0 2px;
    cursor: pointer;
  }
}

.popup-header {
  position: relative;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.nav-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 0 40px 0 12px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.nav-tabs {
  display: inline-flex;
  gap: 12px;
}

.nav-tab {
  display: inline-block;
  padding: 6px 16px;
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.2s ease;
  cursor: pointer;

  &.active {
    color: #fff;
    background: #E7401E;
  }
}

.popup-close {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.popup-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 12px;
  background: #fff;
  -webkit-overflow-scrolling: touch;
}

.imgs {
  text-align: center;
}

.sec-img {
  width: 100%;
  display: block;
  margin-bottom: 6px;
  border-radius: 4px;
}

.popup-footer {
  padding: 12px;
  border-top: 1px solid #eee;
  background: #fff;

  .agree-btn {
    width: 100%;
    padding: 12px 0;
    font-size: 15px;
    color: #fff;
    background: #E7401E;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:active {
      background: #c73018;
    }
  }
}
</style>
